import { useEffect, useState } from 'react'
import { useGetTaskTemplatesQuery, RTK_QUERY_OPTIONS } from 'apiv2'
const { DISABLE_REFETCH_ON_FOCUS } = RTK_QUERY_OPTIONS

export const useTaskDescriptionTemplates = (selectedTypeId, eventType) => {
  const { templates, isFetching } = useGetTaskTemplatesQuery(undefined, {
    DISABLE_REFETCH_ON_FOCUS,
    skip: !selectedTypeId,
    selectFromResult: ({ data, isFetching }) => ({
      isFetching,
      templates: (data ?? []).filter(
        (template) => template.task_type?.id === selectedTypeId
      ),
    }),
  })

  const isCopyTask = eventType === 'copy'
  const isEditTask = eventType === 'edit'

  const hasTemplates = templates.length > 0

  const [isHintVisible, setIsHintVisible] = useState(false)

  useEffect(() => {
    if (!selectedTypeId) {
      setIsHintVisible(false)
      return
    }
    setIsHintVisible(hasTemplates)
  }, [selectedTypeId, hasTemplates])

  const isTemplatesButtonVisible = hasTemplates && !isHintVisible

  const closeHint = () => setIsHintVisible(false)
  const openHint = () => {
    if (hasTemplates) setIsHintVisible(true)
  }

  return {
    templates,
    isFetching,
    hasTemplates,
    shouldShowTemplateHint:
      hasTemplates && isHintVisible && !isCopyTask && !isEditTask,
    isTemplatesButtonVisible,
    closeHint,
    openHint,
  }
}
